module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"title":"为了您能更好的管理金姆 ID，请<span>老账号购买人</span>完成手机绑定。绑定手机后，您可以使用<span>手机号和原始密码</span>登录，<span>原有账号不再做登录使用</span>。如需修改手机号，请登录金姆 ID 官方网站进行修改。","document-title":"绑定手机"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
